import type { PlayerType, VideoBlokData } from './Video.data';

export const getPlayerType = (
  video: VideoBlokData | string | undefined,
): PlayerType | undefined => {
  let filePath;

  if (typeof video === 'string') {
    filePath = video;
  } else {
    filePath = video?.vimeo_url;

    if (video?.hosted_video && video?.hosted_video?.filename?.length > 0) {
      filePath = video?.hosted_video?.filename;
    }
  }

  if (filePath?.includes('//vimeo.com/') && !filePath?.includes('//vimeo.com/manage/')) {
    return 'vimeo';
  }
  if (filePath?.includes('.mp4') || filePath?.includes('.webm')) {
    return 'file';
  }

  return undefined;
};
